import _ from 'underscore';
import { CampaignuiBaseColumn } from '@bingads-webui-campaign/campaignui-base-column';
import { TargetingSettingsContext } from '../targeting-settings-context';
import adGroupColumnTemplate from './template/adgroup-column.pug';

export default class ColumnAdGroup extends CampaignuiBaseColumn {
  constructor({
    i18n,
    gridType,
  }) {
    super({
      name: 'AdGroupName',
      type: 'string',
      property: ['AdGroup/Id', 'AdGroup/Name'],
      sortable: 'AdGroup/Name',
      title: 'ColumnName_AdGroup',
      bodyClasses: ['col-AdGroupName'],
      i18n,
    });

    this.i18n = i18n;
    this.gridType = gridType;
  }

  template({ value }) {
    if (_.isNull(value)) {
      return adGroupColumnTemplate({
        name: '',
      });
    }

    const cid = TargetingSettingsContext.state.get('customer_id');
    const aid = TargetingSettingsContext.state.get('account_id');
    const link = `/campaign/vnext/${this.gridType}?aid=${aid}&cid=${cid}&campaignId=${value.cmpid}&adGroupId=${value.adgid}`;

    return adGroupColumnTemplate({
      link,
      name: value.name,
      campaignId: value.cmpid,
      adgroupId: value.adgid,
      airaLabel: this.i18n.getString('Click to scope to ad group {{adGroupName}}', { adGroupName: value.name }),
    });
  }

  get property() {
    return {
      get: ({ Campaign, AdGroup }) => {
        if (_.isUndefined(Campaign) || _.isUndefined(AdGroup)) {
          return null;
        }

        return {
          cmpid: Campaign.Id,
          adgid: AdGroup.Id,
          name: AdGroup.Name,
        };
      },
      key: this.config.property,
    };
  }
}
